import React, { useState, useEffect } from "react";
import "../../cssfiles/loginpage.css";
import "../../cssfiles/homepage.css";
import Loginpageleftimage from "../../pages/Loginpageleftimage.js";
import brandlogo from "../../images/LKLogo.png";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FormControl,
  Input,
  Typography
} from "@mui/material";
import { useDispatch } from "react-redux";
import { ForgetPassword } from "../../Restclient/datacollection";
import CustomDialogBox from "../CommonComponents/CustomDialogBox.jsx";
 
export default function ForgotPassword() {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");  
  const [dialogType, setDialogType] = useState("Info");    
  const [email, setEmail] = useState("");
  const [isFrozen, setIsFrozen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
 
  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
      setIsFrozen(true); 
    }
  }, [location.state]);
 
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
 
  const handleConfirmDialog = () => {
    setOpenDialog(false);
  };
 
// const handleSubmit = async (e) => {
//   e.preventDefault();
 
//   if (!email) {
//     setDialogMessage("Please enter your email.");
//     setDialogType("Warning");
//     setOpenDialog(true);
//     return;
//   }
 
//   setIsSubmitting(true); 
//   ForgetPassword(email, (response) => {
//     if (response.error) {
//       setDialogMessage("Error sending email. Please try again later.");
//       setDialogType("Error");
//       setOpenDialog(true);
//     } else {
//       setDialogMessage("Email sent successfully. Redirecting to login...");
//       setDialogType("Success");
//       setOpenDialog(true);
 
//       setTimeout(() => {
//         navigate("/");
//       }, 2000);
//     }
//     setIsSubmitting(false);
//   });
// };
 
 
const handleSubmit = async (e) => {
  e.preventDefault();
 
  if (!email) {
    setDialogMessage("Please enter your email.");
    setDialogType("Warning");
    setOpenDialog(true);
    return;
  }
 
  setIsSubmitting(true);
 
  try {
    const response = await ForgetPassword(email); // waits for API to finish
 
    if (response.error) {
      setDialogMessage(response.error);
      setDialogType("Error");
    } else {
      setDialogMessage("Email sent successfully. Redirecting to login...");
      setDialogType("Success");
      setTimeout(() => navigate("/"), 1500);
    }
  } catch (err) {
    setDialogMessage("Something went wrong. Please try again later.");
    setDialogType("Error");
  } finally {
    setOpenDialog(true);
    setIsSubmitting(false);
  }
};
 
  return (
<div className="container">
<div className="left-side">
<Loginpageleftimage />
</div>
<div className="right-side">
<div style={{ display: "flex", flexDirection: "row" }}>
<div style={{ flexGrow: 1 }}></div>
<div className="formcompanylogo">
<img
              src={brandlogo}
              alt="placeholder"
              style={{ marginLeft: "17px", height: "55px", width: "150px" }}
            />
</div>
</div>
<div style={{ display: "flex", flexDirection: "row", marginTop: "50px" }}>
<div style={{ flexGrow: 1 }}></div>
<div className="loginarea">
<div className="loginSignup">
<Typography
                className="signintext"
                style={{
                  fontSize: "30px",
                  fontWeight: 700,
                  marginRight: "135px",
                }}
>
                Forgot Password
</Typography>
</div>
<div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginTop: "25px",
              marginBottom: "25px",
            }}>
<div style={{
                display: "flex",
                textAlign: "start",
                marginBottom: "10px",
                fontSize: "18px",
                fontWeight: "400",
                color: "#3C3C3C"
              }}>
<label htmlFor="username">
                  Email ID
<span className="mandatory" style={{ color: "red", marginLeft: "5px" }}>
                    *
</span>
</label>
</div>
<div>
<FormControl sx={{ m: 1, width: "358px", marginLeft: "2px" }} variant="standard">
<Input
  id="email"
  type="email"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  disabled={isFrozen} 
  style={isFrozen ? { backgroundColor: "#f5f5f5", color: "#666" } : {}}
/>
</FormControl>
</div>
</div>
 
            <div style={{ marginTop: "20px", width: "250px" }}>
<button
                onClick={handleSubmit}
                disabled={isSubmitting} 
                style={{
                  width: "100%",
                  height: "35px",
                  fontSize: "18px",
                  backgroundColor: isSubmitting ? "#A0A0A0" : "#005C8E", 
                  color: "#FFFFFF",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  border: "none",
                  borderRadius: "25px",
                }}
>
                {isSubmitting ? "Sending..." : "Send Reset Link"} 
</button>
 
              <CustomDialogBox
                dialogTitle={dialogType === "Success" ? "Success" : "Error"}
                dialogText={dialogMessage}
                openDialog={openDialog}
                handleCloseDialog={handleCloseDialog}
                handleConfirmDialog={handleConfirmDialog}
                confirmText={"OK"}
                // cancelText={"Cancel"}
                type={dialogType}
              />
</div>
</div>
</div>
</div>
</div>
  );
}